import utils from 'helpers/utils';
import {useServiceStatus} from 'stores/hooks/service';
import {useServiceApiQuery} from 'stores/hooks/query';

const path = utils.servicePath(import.meta.url);

export function useCollectionStatStatus () {
  return useServiceStatus(path);
}

export function useCollectionStatList ({collectionId, stats, stacked, search, filter, ...rest}, queryOptions = {}) {
  return useServiceApiQuery(path, 'list', {collectionId, stats, stacked, search, filter, ...rest}, queryOptions);
}

export function useCollectionStatGet ({collectionId, statId, search, filter, ...rest}, queryOptions = {}) {
  return useServiceApiQuery(path, 'get', {collectionId, statId, search, filter, ...rest}, queryOptions);
}
